import { useEnabledPolicyKinds } from 'src/layout/AgencySettings'

import { isFeeRate } from './useFeeRates'

export default () => useEnabledPolicyKinds().filter((policyKind) => !isFeeRate(policyKind.id))
